export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://dev.api.galadise.com';
export const SHARE_URL = process.env.REACT_APP_SHARE_URL || 'https://dev.gallery.galadise.com';
